import React from "react";
import {
  useBoolean,
  KitCollection,
  SpaceThemeNames,
  KitCollectionItem,
  useNavigation,
} from "@thenounproject/lingo-core";

import KitCollectionCardClassic from "./KitCollectionCardClassic";
import KitCollectionCardDockweiler from "./KitCollectionCardDockweiler";
import KitCollectionCardPismo from "./KitCollectionCardPismo";
import useNavPoint from "@hooks/useNavPoint";

type Props = {
  collection: KitCollection;
  themeName?: SpaceThemeNames;
};
type DenormalizedCollection = Omit<KitCollection, "items"> & { items: KitCollectionItem[] };

const KitCollectionCard: React.FC<Props> = ({ collection, themeName }) => {
  const [menuOpen, setMenuOpen, setMenuClosed] = useBoolean(false),
    navigate = useNavigation();

  const { space } = useNavPoint();

  const popupProps = {
    source: collection.uuid,
    close: setMenuClosed,
    open: menuOpen,
    vPos: undefined,
    hPos: undefined,
    width: 220,
    maxHeight: undefined,
    stayOpenOnClick: false,
    clickAwayClose: true,
    id: "collection-pop-".concat(collection.uuid),
  };

  const cardProps = {
    collection: collection as DenormalizedCollection,
    space,
    menuOpen,
    popupProps,
    setMenuOpen,
    navigate,
  };

  switch (themeName) {
    case SpaceThemeNames.classic: {
      return <KitCollectionCardClassic {...cardProps} />;
    }
    case SpaceThemeNames.scher: {
      return <KitCollectionCardDockweiler {...cardProps} />;
    }
    case SpaceThemeNames.wyman: {
      return <KitCollectionCardPismo {...cardProps} />;
    }
  }
};

export default KitCollectionCard;
